import { createContext } from 'react';

const useCWPAminContext = createContext();
export default useCWPAminContext;
